export const affiliateAndBranchData = (object) => {
  const includedFields = ["affiliate", "branch"];

  const newObjectArray = Object.keys(object)
    .map((key) => {
      if (!includedFields.includes(key)) return null;

      return { label: key, value: object[key].name };
    })
    .filter((item) => item !== null);

  return newObjectArray;
};
